import React from 'react';

import { Container } from './styles';

export const CDNInfo = () => {
  return (
    <>
      <div style={{ padding: '15px' }}>
        <b style={{ color: '#29D975' }}>Conheça as vantagens da CDN</b>
        <p style={{ fontSize: '13px', padding: '10px 0', color: '#64728C' }}>
          <b>1</b> - Navegação mais rápida e melhora de performance da aplicação
        </p>
        <p style={{ fontSize: '13px', padding: '10px 0', color: '#64728C' }}>
          <b>2</b> - Alta tolerância a um fluxo intenso de acessos e maior
          estabilidade para seu site
        </p>
        <p style={{ fontSize: '13px', padding: '10px 0', color: '#64728C' }}>
          <b>3</b> - Mais segurança contra cyber ataques (DDoS)
        </p>
        <p style={{ fontSize: '13px', padding: '10px 0', color: '#64728C' }}>
          <b>4</b> - Redução de consumo de banda de transferência
        </p>
        <p style={{ fontSize: '13px', padding: '10px 0', color: '#64728C' }}>
          <b>5</b> - Redução de sobrecargas no servidor
        </p>
      </div>
    </>
  );
};
